import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UniqueIdService {

  private readonly ALLOWED_CHARS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  private usedIds:string[] = [];
  constructor() { }



  public getUniqueId(length=10) {
    let result = '';

    do {
      for (let  i = length; i > 0; --i) {
        result += this.ALLOWED_CHARS[Math.floor(Math.random() * this.ALLOWED_CHARS.length)]
      }
    }
    while ( this.usedIds.some( oldId => result === oldId));
    this.usedIds.push(result);

    return result;
  }
}
